import React, { useState, useEffect } from "react";
import PagesHeader from "../../components/PageHeader";
import ButtonBar from "../../components/ButtonNavigation/index";
import * as InstallerData from "../../services/InstallerData";
import { useDispatch } from "react-redux";
import { Row, Col, Form, Card, Input, Button, Skeleton, Switch } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  BankOutlined,
  EnvironmentOutlined,
  LockOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

const UpdateInstaller = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showHideCompany, setShowHideCompany] = useState(true);
  const [showHideAddress, setShowHideAddress] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const user_id = queryParams.get("user_id");

  useEffect(() => {
    if (user_id) {
      setLoading(true);
      dispatch(InstallerData.getSingleInstaller(user_id))
        .then((res) => {
          const isCompanyEnabled = res.company_info === "enable" || !!res.comp_name;
          const isAddressEnabled = res.shipping_info === "enable" || !!res.street;

          setShowHideCompany(isCompanyEnabled);
          setShowHideAddress(isAddressEnabled);

          form.setFieldsValue({
            user_name: res.user_name,
            email_add: res.email_add,
            pwd: res.password,
            confirm_pass: res.password,
            first_name: res.first_name,
            last_name: res.last_name,
            phone_personal: res.phone_personal,
            comp_name: res.comp_name,
            phone: res.phone,
            comp_email: res.comp_email,
            comp_type: res.comp_type,
            website: res.website,
            street: res.street,
            city: res.city,
            state: res.state,
            country: res.country,
            zip_code: res.zip_code,
          });
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [dispatch, form, user_id]);

  const onFinish = (values) => {
    setSubmitting(true);
    values.user_id = user_id;
    values.company_info = showHideCompany ? "enable" : "disable";
    values.shipping_info = showHideAddress ? "enable" : "disable";

    dispatch(InstallerData.updateInstallerData(values))
      .then(() => {
        setSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Installer details updated successfully.",
          confirmButtonColor: "#0a497b",
        }).then(() => {
          navigate("/single-installer/?user_id=" + user_id);
        });
      })
      .catch(() => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update installer details.",
          confirmButtonColor: "#0a497b",
        });
      });
  };

  const cardStyle = {
    borderRadius: "16px",
    border: "1px solid #cbd5e1",
    boxShadow: "0 10px 25px rgba(10, 73, 123, 0.05)",
    marginBottom: "24px",
    background: "#ffffff",
    overflow: "hidden",
  };

  const headerBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #0a497b 0%, #0284c7 100%)",
    color: "#ffffff",
    fontSize: "18px",
    marginRight: "12px",
    boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
  };

  const inputStyle = {
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    boxShadow: "none",
  };

  return (
    <div className="inspectionWrapper" style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="inspectionHeader">
        <PagesHeader title="Edit Installer Profile" type="secondary" />
      </div>
      <div className="buttonSection" style={{ position: "relative", zIndex: 100 }}>
        <div className="container-xxl">
          <Row align="middle" justify="space-between">
            <Col xs={24} md={16} className="text-end">
              <ButtonBar />
            </Col>
            <Col xs={24} md={8} className="text-end">
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(`/single-installer/?user_id=${user_id}`)}
                style={{
                  borderRadius: "20px",
                  fontWeight: 600,
                  borderColor: "#cbd5e1",
                  color: "#475569",
                }}
              >
                Back to Profile
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      <div className="inspectionWrapInner mt-3">
        <div className="container-xxl" style={{ maxWidth: "1100px" }}>
          {loading ? (
            <Card style={cardStyle}>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          ) : (
            <Form form={form} layout="vertical" onFinish={onFinish}>
              {/* 1. Company Information Card */}
              <Card
                style={cardStyle}
                title={
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={headerBadgeStyle}>
                        <BankOutlined />
                      </span>
                      <div>
                        <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                          Company Information
                        </h5>
                        <span style={{ fontSize: "12px", color: "#64748b", fontWeight: 400 }}>
                          Manage company contact & details
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f1f5f9", padding: "6px 16px", borderRadius: "20px" }}>
                      <span style={{ fontWeight: 600, fontSize: "13px", color: "#475569" }}>
                        Enable Company Info
                      </span>
                      <Switch checked={showHideCompany} onChange={(chk) => setShowHideCompany(chk)} />
                    </div>
                  </div>
                }
              >
                {showHideCompany ? (
                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item name="comp_name" label={<span style={{ fontWeight: 600, color: "#334155" }}>Company Name</span>}>
                        <Input className="formControl" prefix={<BankOutlined style={{ color: "#94a3b8" }} />} placeholder="Company Name" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item name="website" label={<span style={{ fontWeight: 600, color: "#334155" }}>Website</span>}>
                        <Input className="formControl" prefix={<GlobalOutlined style={{ color: "#94a3b8" }} />} placeholder="Website URL" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="comp_email" label={<span style={{ fontWeight: 600, color: "#334155" }}>Company Email</span>}>
                        <Input className="formControl" prefix={<MailOutlined style={{ color: "#94a3b8" }} />} placeholder="Email" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="phone" label={<span style={{ fontWeight: 600, color: "#334155" }}>Company Phone</span>}>
                        <Input className="formControl" prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />} placeholder="Phone" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="comp_type" label={<span style={{ fontWeight: 600, color: "#334155" }}>Company Type</span>}>
                        <Input className="formControl" placeholder="Company Type" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <div style={{ textAlign: "center", padding: "12px 0", color: "#94a3b8" }}>
                    Company information section is disabled.
                  </div>
                )}
              </Card>

              {/* 2. Mailing and Shipping Address Card */}
              <Card
                style={cardStyle}
                title={
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={headerBadgeStyle}>
                        <EnvironmentOutlined />
                      </span>
                      <div>
                        <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                          Mailing and Shipping Address
                        </h5>
                        <span style={{ fontSize: "12px", color: "#64748b", fontWeight: 400 }}>
                          Manage location and shipping info
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f1f5f9", padding: "6px 16px", borderRadius: "20px" }}>
                      <span style={{ fontWeight: 600, fontSize: "13px", color: "#475569" }}>
                        Enable Address Info
                      </span>
                      <Switch checked={showHideAddress} onChange={(chk) => setShowHideAddress(chk)} />
                    </div>
                  </div>
                }
              >
                {showHideAddress ? (
                  <Row gutter={20}>
                    <Col xs={24} md={12}>
                      <Form.Item name="street" label={<span style={{ fontWeight: 600, color: "#334155" }}>Street</span>}>
                        <Input className="formControl" prefix={<EnvironmentOutlined style={{ color: "#94a3b8" }} />} placeholder="Street" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item name="city" label={<span style={{ fontWeight: 600, color: "#334155" }}>City</span>}>
                        <Input className="formControl" placeholder="City" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="state" label={<span style={{ fontWeight: 600, color: "#334155" }}>State</span>}>
                        <Input className="formControl" placeholder="State" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="country" label={<span style={{ fontWeight: 600, color: "#334155" }}>Country</span>}>
                        <Input className="formControl" placeholder="Country" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item name="zip_code" label={<span style={{ fontWeight: 600, color: "#334155" }}>Zip Code</span>}>
                        <Input className="formControl" placeholder="Zip Code" size="large" style={inputStyle} />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <div style={{ textAlign: "center", padding: "12px 0", color: "#94a3b8" }}>
                    Mailing and shipping address section is disabled.
                  </div>
                )}
              </Card>

              {/* 3. Login Information Card */}
              <Card
                style={cardStyle}
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={headerBadgeStyle}>
                      <LockOutlined />
                    </span>
                    <div>
                      <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>
                        Login Information
                      </h5>
                      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: 400 }}>
                        Personal profile & login credentials
                      </span>
                    </div>
                  </div>
                }
              >
                <Row gutter={20}>
                  <Col xs={24} md={8}>
                    <Form.Item name="email_add" label={<span style={{ fontWeight: 600, color: "#334155" }}>Email Address (Login ID)</span>}>
                      <Input className="formControl" disabled prefix={<MailOutlined style={{ color: "#94a3b8" }} />} placeholder="Email Address" size="large" style={{ ...inputStyle, background: "#f1f5f9", cursor: "not-allowed" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="pwd" label={<span style={{ fontWeight: 600, color: "#334155" }}>Password</span>}>
                      <Input.Password className="formControl" prefix={<LockOutlined style={{ color: "#94a3b8" }} />} placeholder="Password" size="large" style={inputStyle} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="confirm_pass"
                      label={<span style={{ fontWeight: 600, color: "#334155" }}>Confirm Password</span>}
                      dependencies={["pwd"]}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("pwd") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error("Passwords do not match!"));
                          },
                        }),
                      ]}
                    >
                      <Input.Password className="formControl" prefix={<LockOutlined style={{ color: "#94a3b8" }} />} placeholder="Confirm Password" size="large" style={inputStyle} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="first_name" label={<span style={{ fontWeight: 600, color: "#334155" }}>First Name</span>}>
                      <Input className="formControl" placeholder="First Name" size="large" style={inputStyle} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="last_name" label={<span style={{ fontWeight: 600, color: "#334155" }}>Last Name</span>}>
                      <Input className="formControl" placeholder="Last Name" size="large" style={inputStyle} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="phone_personal" label={<span style={{ fontWeight: 600, color: "#334155" }}>Personal Phone</span>}>
                      <Input className="formControl" prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />} placeholder="Personal Phone" size="large" style={inputStyle} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              {/* Bottom Action Bar */}
              <div
                style={{
                  background: "#ffffff",
                  padding: "16px 24px",
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "1px solid #cbd5e1",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  size="large"
                  onClick={() => navigate(`/single-installer/?user_id=${user_id}`)}
                  style={{
                    borderRadius: "10px",
                    fontWeight: 600,
                    padding: "0 24px",
                  }}
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitting}
                  icon={<CheckCircleOutlined />}
                  size="large"
                  style={{
                    borderRadius: "10px",
                    fontWeight: 700,
                    padding: "0 32px",
                    background: "linear-gradient(135deg, #0a497b 0%, #0284c7 100%)",
                    borderColor: "transparent",
                    boxShadow: "0 4px 16px rgba(2, 132, 199, 0.35)",
                  }}
                >
                  Update Installer Profile
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateInstaller;
